import type {
  IDatabaseResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IDatabaseResponseInstance'
import type {
  IDatabaseViewResponseInstance,
} from '@toolify/server/src/controllers/DatabaseViewController/types/IDatabaseViewResponseInstance'
import {getDefaultDatabaseViewId} from '@toolify/client/src/modules/databases/functions/getDefaultDatabaseViewId'

export function getPreferredDatabaseViewId(
  database: Pick<IDatabaseResponseInstance, 'id' | 'defaultDatabaseViewId'>,
  databaseViews: Pick<IDatabaseViewResponseInstance, 'id' | 'position'>[],
): string | null {
  const lastUserDatabaseViewId = window.localStorage.getItem(`current-view-db-${database.id}`)
  if(lastUserDatabaseViewId && databaseViews.some(view => view.id === lastUserDatabaseViewId)) {
    return lastUserDatabaseViewId
  }
  return getDefaultDatabaseViewId(database, databaseViews)
}
